// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__jIhCY","text":"delete-modal_text__z46S-","source":"delete-modal_source__HPRIM","button":"delete-modal_button__u+vRO"};